import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import { ThemeProvider } from './contexts/ThemeContext';
import { ToastProvider } from './components/ui/toast';
import { ToastProvider as LegacyToastProvider } from './contexts/ToastContext';
import './styles/globals.css';
import './index.css';
import './i18n'; // Initialize i18n

const rootElement = document.getElementById('root');
if (!rootElement) {
  throw new Error('Root element not found');
}

ReactDOM.createRoot(rootElement).render(
  <React.StrictMode>
    <ThemeProvider>
      <ToastProvider>
        <LegacyToastProvider>
          <App />
        </LegacyToastProvider>
      </ToastProvider>
    </ThemeProvider>
  </React.StrictMode>
);
